// Live chat with Odearly care. Talks to the API; the thread id lives in localStorage so a reload keeps the conversation.
(() => {
  const API = (window.ODEARLY_API || "https://odearly-api.vercel.app").replace(/\/$/, "");
  const KEY = "odearly-chat-v1";
  let state = { sid: null, history: [], open: false };
  try { state = { ...state, ...(JSON.parse(localStorage.getItem(KEY)) || {}) }; } catch {}
  if (!state.sid) state.sid = Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => (b % 36).toString(36)).join("");
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify({ sid: state.sid, history: state.history.slice(-30) })); } catch {} };

  const root = document.createElement("div");
  root.className = "chat";
  root.innerHTML = `
    <button class="chat__bubble" type="button" aria-expanded="false" aria-controls="odearly-chat"><i class="ph-fill ph-chat-circle-dots" aria-hidden="true"></i><span>Chat with us</span></button>
    <section class="chat__panel" id="odearly-chat" hidden aria-label="Chat with Odearly">
      <header class="chat__head">
        <svg class="chat__mark" viewBox="-14.15 -80.07 94.16 94.16" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M 2.55 -32.99 A 30.38 30.38 0 1 0 63.31 -32.99 A 30.38 30.38 0 1 0 2.55 -32.99 Z M 32.93 -19.01 C 31.11 -20.23 16.53 -28.12 16.53 -37.54 C 16.53 -43.01 20.48 -46.35 24.73 -46.35 C 28.37 -46.35 31.41 -44.53 32.93 -41.79 C 34.45 -44.53 37.49 -46.35 41.13 -46.35 C 45.38 -46.35 49.33 -43.01 49.33 -37.54 C 49.33 -28.12 34.75 -20.23 32.93 -19.01 Z"/></svg>
        <div><strong>Odearly care</strong><small><i class="chat__dot" aria-hidden="true"></i> Online now</small></div>
        <button class="chat__close" type="button" aria-label="Close chat"><i class="ph ph-x" aria-hidden="true"></i></button>
      </header>
      <div class="chat__log" role="log" aria-live="polite"></div>
      <form class="chat__form">
        <input class="chat__input" type="text" name="text" placeholder="Ask anything about your song" autocomplete="off" maxlength="600" required>
        <button class="chat__send" type="submit" aria-label="Send"><i class="ph-fill ph-paper-plane-right" aria-hidden="true"></i></button>
      </form>
    </section>`;
  document.body.appendChild(root);
  const bubble = root.querySelector(".chat__bubble"), panel = root.querySelector(".chat__panel"), log = root.querySelector(".chat__log"), form = root.querySelector(".chat__form"), input = root.querySelector(".chat__input");

  const add = (role, text) => {
    const el = document.createElement("p");
    el.className = `chat__msg chat__msg--${role}`;
    el.textContent = text;
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  };
  const paint = () => {
    log.innerHTML = "";
    if (!state.history.length) add("assistant", "Hi! Questions about your song, a change, an order? Ask me here.");
    state.history.forEach((m) => add(m.role, m.text));
  };
  const setOpen = (open) => {
    state.open = open;
    panel.hidden = !open;
    bubble.setAttribute("aria-expanded", String(open));
    root.classList.toggle("is-open", open);
    if (open) { paint(); setTimeout(() => input.focus(), 50); }
  };
  bubble.addEventListener("click", () => setOpen(panel.hidden));
  root.querySelector(".chat__close").addEventListener("click", () => setOpen(false));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !panel.hidden) setOpen(false); });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const text = input.value.trim();
    if (!text) return;
    input.value = "";
    state.history.push({ role: "user", text }); add("user", text);
    const typing = add("assistant", "…"); typing.classList.add("chat__msg--typing");
    try {
      const res = await fetch(`${API}/api/support/chat`, { method: "POST", headers: { "Content-Type": "application/json", "X-Odearly": "1" }, body: JSON.stringify({ sid: state.sid, text, history: state.history.slice(-12) }) });
      const data = res.ok ? await res.json() : null;
      typing.remove();
      const answer = data?.answer || "We're having trouble right now. Write to odearly@odearly.com and we'll answer within one business day.";
      state.history.push({ role: "assistant", text: answer }); add("assistant", answer);
    } catch {
      typing.remove();
      add("assistant", "Connection lost. Write to odearly@odearly.com and we'll answer within one business day.");
    }
    save();
  });
})();
